__turbopack_context__.v({
  "pill": "Pill-module__17-CAW__pill",
});
